<template>
  <div class="fixed top-5 right-5 z-[1000] flex flex-col gap-3">
    <transition-group name="fade">
      <div
        v-for="t in toasts"
        :key="t.id"
        :class="[
          'rounded-lg shadow-md px-4 py-3 text-sm min-w-[240px] border flex items-center gap-2',
          t.type === 'success' && 'bg-green-100 text-green-800 border-green-300',
          t.type === 'error' && 'bg-red-100 text-red-800 border-red-300',
          t.type === 'warning' && 'bg-yellow-100 text-yellow-800 border-yellow-300'
        ]"
      >
        <span v-if="t.type === 'success'">✅</span>
        <span v-else-if="t.type === 'error'">❌</span>
        <span v-else-if="t.type === 'warning'">⚠️</span>
        <span class="font-medium">{{ t.message }}</span>
      </div>
    </transition-group>
  </div>
</template>

<script setup>
import { useToastStore } from '@/stores/toastStore'
const { toasts } = useToastStore()
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: all 0.4s ease;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
</style>